// Doplňuje <td data-label="…"> podle <th>, aby se tabulky na mobilu daly zobrazit jako karty (CSS v index.css).
function labelTable(table) {
    const ths = Array.from(table.querySelectorAll(":scope > thead th"));
    if (!ths.length) return;
    const labels = ths.map((th) => th.textContent.trim());
    table.querySelectorAll(":scope > tbody > tr").forEach((tr) => {
        const tds = Array.from(tr.children);
        if (tds.length === 1 && tds[0].colSpan > 1) { tds[0].setAttribute("data-empty", "1"); return; }
        tds.forEach((td, i) => {
            const label = labels[i];
            if (label) td.setAttribute("data-label", label);
            else if (i === tds.length - 1) td.setAttribute("data-actions", "1");
        });
    });
}

export function setupMobileTables(root = document.body) {
    const run = () => root.querySelectorAll("main table").forEach(labelTable);
    run();
    let scheduled = false;
    const obs = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; run(); });
    });
    obs.observe(root, { childList: true, subtree: true });
    return () => obs.disconnect();
}
